package meineglasfaser.api

enum class IncidentStatus {
    REPORTED,
    INVESTIGATING,
    IDENTIFIED,
    WATCHING,
    FIXED;
}

enum class IncidentLevel {
    UNKNOWN,
    DEGRADED,
    PARTIAL,
    MAJOR;
}
